/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypeTextIcon20Light = forwardRef('FileTypeTextIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H10v5.5a.5.5 0 0 1-1 0V8H6.5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 5a3 3 0 0 1 3-3h3.622a1.5 1.5 0 0 1 1.06.44l3.879 3.877A1.5 1.5 0 0 1 16 7.378V15a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5Zm3-2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7.378a.5.5 0 0 0-.146-.354l-3.878-3.878A.5.5 0 0 0 10.622 3H7Z" })));
});
